import { MultipleChoiceOptionJson, RatingScaleOptionJson, SurveyQuestionJson } from "@performyard/service-contracts";
import { isString } from "@performyard/utils-isomorphic";

export const MAX_NAME_LENGTH = 250;
export const MAX_QUESTION_LENGTH = 3000;

export const cleanQuestions = (questions: SurveyQuestionJson[]) => {
	return questions.map(postProccessQuestion);
};

export const postProccessQuestion = (question: SurveyQuestionJson & { isNew?: boolean }) => {
	switch (question.type) {
		case "multiple-select":
		case "multiple-choice": {
			// remove and trim choices
			const proccessedOptions = question?.options
				?.filter((option): option is MultipleChoiceOptionJson => typeof option === "object")
				.map((option) => ({
					...option,
					text: option.text.trim(),
				}));
			return { ...question, options: proccessedOptions };
		}
		case "rating-scale": {
			const proccessedOptions = question?.options
				?.filter((option): option is RatingScaleOptionJson => !isString(option))
				.map((option) => ({
					...option,
					value: isString(option.value) ? null : option.value,
				}));
			return { ...question, options: proccessedOptions };
		}
		default:
			// if the subtitle is an empty string, set it to undefined
			if (question.subtitle === "") {
				question.subtitle = undefined;
			}
			return question;
	}
};
